import RequestAbstract from "./RequestAbstract";

export default class Invoices extends RequestAbstract {
    get link() {
        return this.links.invoices;
    }

    async getAllForClient(clientId, isPerMode, showCanceled, sort) {
        let stat = [];
        if (isPerMode)
            stat.push("PRE_CREATED");
        else
            stat = ["CREATED", "PAID", "PARTIALLY_PAID", "PRE_CREATED"];

        if (showCanceled)
            stat.push(isPerMode ? "PRE_CANCELLED" : "CANCELLED");

        if (sort)
            return this.getAllFiltered([
                [
                    { field: "clientId", op: "=", value: clientId },
                    { field: "status", op: "@", value: stat },
                ]
            ], this.getSortField(sort));

        return this.getAllFiltered([
            [
                { field: "clientId", op: "=", value: clientId },
                { field: "status", op: "@", value: stat },
            ]
        ]);
    }

    async getDetails(id) {
        return this.get(this.links.invoicesDetails + "/" + id);
    }

    async getInvoiceByVisitId(visitid, isPerMode, showCanceled) {
        let stat = [];
        if (isPerMode)
            stat.push("PRE_CREATED");
        else
            stat = ["CREATED", "PAID", "PARTIALLY_PAID"];

        if (showCanceled)
            stat.push(isPerMode ? "PRE_CANCELLED" : "CANCELLED");

        const req = await this.getAllFiltered([
            [
                { field: "workItemId", op: "=", value: visitid },
                { field: "status", op: "@", value: stat },
            ]
        ]);
        return req;
    }
}
